import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import { authReducer, authSaga } from "../app/modules/Auth";

import { paymentReducer, paymentSaga } from "../app/modules/Payment";
import { receiptSaga, receiptReducer } from "../app/modules/ReceiptRetrieval";
import { deptReducer, deptSaga } from "../app/modules/Information/Department";
import { catalogueReducer, catalogueSaga } from "../app/modules/Catalogue";
import { serviceReducer, serviceSaga } from "../app/modules/Information/Service";
import { serviceItemReducer, serviceItemSaga } from "../app/modules/Information/ServiceItem";
import { refReducer, refSaga } from "../app/modules/Information/Reference";
import { uiReducer, uiSaga } from "../app/modules/UI";
import { provReducer, provSaga } from "../app/modules/Information/Province";
import { regionReducer, regionSaga } from "../app/modules/Information/Regions";


const appReducer = combineReducers({
  auth: authReducer,
  receipt:receiptReducer, 
  dept: deptReducer,
  serv: serviceReducer,
  servItem: serviceItemReducer,
  catalogue: catalogueReducer,
  payment: paymentReducer,
  reference: refReducer,
  ui: uiReducer,
  province: provReducer,
  region: regionReducer,
});

export const rootReducer = (state, action) => {
  //if ( action.type.localeCompare(authReducerActions.loggedOut) === 0) {
      // for all keys defined in your persistConfig(s)
      // storage.removeItem('persist:reference-entities');
      // storage.removeItem('persist:case-worker-entities');
      // storage.removeItem('persist:user-access-key');
      // storage.removeItem('persist:root');

      //state = undefined;
  //}
  return appReducer(state, action);
};

export function* rootSaga() {
  yield all([
    authSaga(),
    receiptSaga(),
    deptSaga(),
    serviceSaga(),
    serviceItemSaga(),
    catalogueSaga(),
    paymentSaga(),
    refSaga(),
    uiSaga(),
    provSaga(),
    regionSaga(),
  ]);
};